module.exports = __webpack_public_path__ + "img/img-eb51e5.png";